import IComponent from "components/commons/IComponent";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
class LayerDropDown extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return (
      <div>
        <EditableDatagridCell
          key="layer_dropdown"
          cellInfo={{
            colDef: {
              field: "activeLayer",
              dataType: "dropdown",
              values: this.props.layers.map((i) => i.title),
              required: true,
            },

            row: this.props,
            key: "layer_dropdown",
          }}
          onChange={this.onChangeHandler.bind(this)}
        />
      </div>
    );
  }
  onChangeHandler(field, value, values) {
    console.log("item", field, value, values);
    this.props.onChange(value);
  }
}
export default LayerDropDown;
